import { Dropdown as PrimeDropdown } from "primereact/dropdown";
import styled from "styled-components";

import { TextInputMixin } from "./styles";

export type { DropdownChangeEvent } from "primereact/dropdown";
export { MultiSelect } from "primereact/multiselect";

export const Dropdown = styled(PrimeDropdown)<{ err?: Error }>`
  ${TextInputMixin}

  .p-dropdown-label {
    padding-right: 40px;
    text-overflow: ellipsis;
  }

  .p-dropdown-trigger {
    background: var(--primaryColor090);
    margin: 0;
    display: inline-flex;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    align-items: center;
    vertical-align: bottom;
    text-align: center;
    overflow: hidden;
    position: relative;
    width: 2.057rem;
    padding: 0.5rem 0;

    svg {
      color: var(--white-color);
    }
  }
`;
